import { render, staticRenderFns } from "./extensionTable.vue?vue&type=template&id=08ab95e0&scoped=true&"
import script from "./extensionTable.vue?vue&type=script&lang=js&"
export * from "./extensionTable.vue?vue&type=script&lang=js&"
import style0 from "./extensionTable.vue?vue&type=style&index=0&id=08ab95e0&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab95e0",
  null
  
)

export default component.exports